module.exports = __webpack_public_path__ + "static/media/t3.48aa39b5.png";